var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell-repeats px--medium block max-w-full"},[_c('EllipsisLabel',{attrs:{"label":_vm.getRepeatSequence}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }